import { baggageHeaderToDynamicSamplingContext } from './baggage.js';
import { uuid4 } from './misc.js'; // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here

var TRACEPARENT_REGEXP = new RegExp('^[ \\t]*' + // whitespace
'([0-9a-f]{32})?' + // trace_id
'-?([0-9a-f]{16})?' + // span_id
'-?([01])?' + // sampled
'[ \\t]*$');
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */

function extractTraceparentData(traceparent) {
  if (!traceparent) {
    return undefined;
  }

  var matches = traceparent.match(TRACEPARENT_REGEXP);

  if (!matches) {
    return undefined;
  }

  var parentSampled;

  if (matches[3] === '1') {
    parentSampled = true;
  } else if (matches[3] === '0') {
    parentSampled = false;
  }

  return {
    traceId: matches[1],
    parentSampled: parentSampled,
    parentSpanId: matches[2]
  };
}
/**
 * Create tracing context from incoming headers.
 *
 * @deprecated Use `propagationContextFromHeaders` instead.
 */
// TODO(v8): Remove this function


function tracingContextFromHeaders(sentryTrace, baggage) {
  var traceparentData = extractTraceparentData(sentryTrace);
  var dynamicSamplingContext = baggageHeaderToDynamicSamplingContext(baggage);

  var _ref = traceparentData || {},
      traceId = _ref.traceId,
      parentSpanId = _ref.parentSpanId,
      parentSampled = _ref.parentSampled;

  if (!traceparentData) {
    return {
      traceparentData: traceparentData,
      dynamicSamplingContext: undefined,
      propagationContext: {
        traceId: traceId || uuid4(),
        spanId: uuid4().substring(16)
      }
    };
  } else {
    return {
      traceparentData: traceparentData,
      dynamicSamplingContext: dynamicSamplingContext || {},
      // If we have traceparent data but no DSC it means we are not head of trace and we must freeze it
      propagationContext: {
        traceId: traceId || uuid4(),
        parentSpanId: parentSpanId || uuid4().substring(16),
        spanId: uuid4().substring(16),
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {} // If we have traceparent data but no DSC it means we are not head of trace and we must freeze it

      }
    };
  }
}
/**
 * Create a propagation context from incoming headers.
 */


function propagationContextFromHeaders(sentryTrace, baggage) {
  var traceparentData = extractTraceparentData(sentryTrace);
  var dynamicSamplingContext = baggageHeaderToDynamicSamplingContext(baggage);

  var _ref2 = traceparentData || {},
      traceId = _ref2.traceId,
      parentSpanId = _ref2.parentSpanId,
      parentSampled = _ref2.parentSampled;

  if (!traceparentData) {
    return {
      traceId: traceId || uuid4(),
      spanId: uuid4().substring(16)
    };
  } else {
    return {
      traceId: traceId || uuid4(),
      parentSpanId: parentSpanId || uuid4().substring(16),
      spanId: uuid4().substring(16),
      sampled: parentSampled,
      dsc: dynamicSamplingContext || {} // If we have traceparent data but no DSC it means we are not head of trace and we must freeze it

    };
  }
}
/**
 * Create sentry-trace header from span context values.
 */


function generateSentryTraceHeader() {
  var traceId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : uuid4();
  var spanId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : uuid4().substring(16);
  var sampled = arguments.length > 2 ? arguments[2] : undefined;
  var sampledString = '';

  if (sampled !== undefined) {
    sampledString = sampled ? '-1' : '-0';
  }

  return "".concat(traceId, "-").concat(spanId).concat(sampledString);
}

export { TRACEPARENT_REGEXP, extractTraceparentData, generateSentryTraceHeader, propagationContextFromHeaders, tracingContextFromHeaders };